import React, { useState } from "react";
import { useData, save } from "../hooks/useData";
import { toast } from "sonner";
import { PageHeader, DataTable, Button, Modal, Field, Input, Textarea } from "../components/shared";
import { Plus } from "lucide-react";

function PartyPage({ coll, title, subtitle }) {
  const { data, loading, reload } = useData(`/${coll}`);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(null);
  const blank = { name: "", contact_person: "", phone: "", email: "", gstin: "", address: "", remarks: "" };
  const edit = (r) => { setForm(r ? { ...r } : blank); setOpen(true); };
  const submit = async (e) => {
    e.preventDefault();
    await save(form.id ? "put" : "post", form.id ? `/${coll}/${form.id}` : `/${coll}`, form);
    toast.success("Saved"); setOpen(false); reload();
  };
  const columns = [
    { key: "name", header: "Name", render: (r) => <span className="font-medium text-slate-800">{r.name}</span> },
    { key: "contact_person", header: "Contact" },
    { key: "phone", header: "Phone" },
    { key: "gstin", header: "GSTIN", mono: true },
    { key: "address", header: "Address" },
    { key: "act", header: "", sortable: false, render: (r) => <Button size="sm" variant="ghost" onClick={(e) => { e.stopPropagation(); edit(r); }}>Edit</Button> },
  ];
  return (
    <div>
      <PageHeader title={title} subtitle={subtitle}>
        <Button onClick={() => edit(null)} data-testid={`add-${coll}-btn`}><Plus size={15} /> Add</Button>
      </PageHeader>
      {!loading && <DataTable testid={`${coll}-table`} columns={columns} rows={data} exportName={`${coll}.csv`} onRowClick={(r) => edit(r)} />}
      <Modal open={open} onClose={() => setOpen(false)} title={form?.id ? "Edit" : "Add New"}>
        {form && (
          <form onSubmit={submit} className="grid grid-cols-2 gap-4">
            <Field label="Name" required className="col-span-2"><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid={`${coll}-name`} /></Field>
            <Field label="Contact Person"><Input value={form.contact_person} onChange={(e) => setForm({ ...form, contact_person: e.target.value })} /></Field>
            <Field label="Phone"><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></Field>
            <Field label="Email"><Input type="email" value={form.email || ""} onChange={(e) => setForm({ ...form, email: e.target.value })} /></Field>
            <Field label="GSTIN"><Input value={form.gstin} onChange={(e) => setForm({ ...form, gstin: e.target.value })} /></Field>
            <Field label="Address" className="col-span-2"><Textarea value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></Field>
            <div className="col-span-2 flex justify-end gap-2 pt-2">
              <Button type="button" variant="secondary" onClick={() => setOpen(false)}>Cancel</Button>
              <Button type="submit" data-testid={`${coll}-save`}>Save</Button>
            </div>
          </form>
        )}
      </Modal>
    </div>
  );
}

export const Suppliers = () => <PartyPage coll="suppliers" title="Suppliers" subtitle="Fabric & accessory suppliers" />;
export const Customers = () => <PartyPage coll="customers" title="Customers" subtitle="Buyers / retail partners" />;
